import script from "./ChatSidebarUser.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatSidebarUser.vue?vue&type=script&setup=true&lang=js"

import "./ChatSidebarUser.vue?vue&type=style&index=0&id=7a163716&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a163716"]])

export default __exports__